export const MilkmanLogo = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="16"
      fill="none"
      viewBox="0 0 13 16"
			{...props}
    >
      <path
        fill="#4F4F4F"
        d="M7.132 2.474l-.028.002-.082-.021a3.08 3.08 0 01-.44-.326H6.58a3.412 3.412 0 00-.249-.196.209.209 0 01-.098-.203c.027-.217.37-.378 1.453-.784L7.72.934h.002c.251-.095.484-.183.598-.24.143-.07.272-.205.397-.335V.358C8.894.174 9.06 0 9.278 0c.083 0 .164.027.24.08.342.239.341.7.341 1.006v.024c0 .047 0 .09.002.127.005.097.264.297.491.41.062.03.096.097.086.164a.16.16 0 01-.133.131l-3.172.532zM2.142 13.527a6.197 6.197 0 004.303-1.94c-1.245-.294-1.388-.586-1.508-1.412a4.044 4.044 0 01-2.87 1.32 4.141 4.141 0 01-.839-.057c-.568-.098-1.112.273-1.212.824-.1.551.28 1.08.849 1.177.416.072.848.1 1.277.088z"
      ></path>
      <path
        fill="#4F4F4F"
        d="M5.942 11.19c.251.067.5.15.738.246l.006.002c1.6.657 2.846 2.009 3.33 3.616a1.048 1.048 0 001.299.69c.553-.157.872-.721.71-1.259-.628-2.081-2.15-3.817-4.18-4.767h-.001l-.002-.001a7.964 7.964 0 00-1.356-.49.112.112 0 01-.081-.139.115.115 0 01.141-.079c.445.116.88.27 1.294.457.264-.525.497-1.074.691-1.639l.036-.102c.259-.765.45-1.557.57-2.355a.992.992 0 00-.073-.548V4.82l-.01-.017-.014-.027v-.005a1.024 1.024 0 00-.655-.525 6.746 6.746 0 00-3.096-.087 6.628 6.628 0 00-2.053.796 1 1 0 00-.343 1.397c.192.303.526.484.893.484.192 0 .38-.052.546-.15a4.568 4.568 0 012.399-.636h.003c.367.007.733.058 1.09.155.062.017.098.08.08.139a.116.116 0 01-.143.079 4.127 4.127 0 00-.94-.144 11.28 11.28 0 01-1.494 3.39c-.054.087-.096.18-.122.273-.046.142-.098.96.737 1.247z"
      ></path>
      <path
        fill="#4F4F4F"
        d="M8.809 7.729c.252-.756.44-1.539.557-2.327l.006-.05a4.38 4.38 0 002.1 1.633c.538.2.807.79.602 1.314-.155.39-.548.65-.978.65-.129 0-.254-.022-.374-.067A6.124 6.124 0 018.81 7.729z"
      ></path>
    </svg>
  );
}
